const gridFooterHeight = 60
const gridTopPanelHeight = 75
const gridFilterHeight = 79
const gridBodyMargin = 65
const scrollbarWidth = 15

export const gridLayoutHeight = gridTopPanelHeight + gridFilterHeight + gridFooterHeight + gridBodyMargin + scrollbarWidth
export const rowHeight = 40
